module.exports = __webpack_public_path__ + "img/second_zhTc_new.c0eb1819.png";